import { render, staticRenderFns } from "./SolutionList.vue?vue&type=template&id=2d78ee4e&scoped=true"
import script from "./SolutionList.vue?vue&type=script&lang=js"
export * from "./SolutionList.vue?vue&type=script&lang=js"
import style0 from "./SolutionList.vue?vue&type=style&index=0&id=2d78ee4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d78ee4e",
  null
  
)

export default component.exports